// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as DTS_Types from "../DTS.Types/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var bind = /* #__PURE__ */ Control_Bind.bind(/* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity));
var readImpl = /* #__PURE__ */ Simple_JSON.readImpl(Simple_JSON.readString);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(/* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity));
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var EmailValidationPhase = function (x) {
    return x;
};
var tsBridgeEmailValidationPh = {
    tsBridge: function (v) {
        return pure(new DTS_Types.TsTypeIntersection([ new DTS_Types.TsTypeUnion([ new DTS_Types.TsTypeTypelevelString("idle"), new DTS_Types.TsTypeTypelevelString("loading"), new DTS_Types.TsTypeTypelevelString("success"), new DTS_Types.TsTypeTypelevelString("error") ]), new DTS_Types.TsTypeRecord([ new DTS_Types.TsRecordField("__brandEmailValidationPhase", {
            readonly: true,
            optional: false
        }, new DTS_Types.TsTypeTypelevelString("EmailValidationPhase")) ]) ]));
    }
};
var showEmailValidationPhase = Data_Show.showString;
var ordEmailValidationPhase = Data_Ord.ordString;
var eqEmailValidationPhase = Data_Eq.eqString;
var emailValidationPhaseToString = function (v) {
    return v;
};
var writeEmailValidationPhase = {
    writeImpl: /* #__PURE__ */ (function () {
        var $19 = Simple_JSON.writeImpl(Simple_JSON.writeForeignString);
        return function ($20) {
            return $19(emailValidationPhaseToString($20));
        };
    })()
};
var emailValidationPhaseSuccess = "success";
var emailValidationPhaseLoading = "loading";
var emailValidationPhaseIdle = "idle";
var emailValidationPhaseError = "error";
var emailValidationPhaseFromString = function (value) {
    if (value === "idle") {
        return new Data_Maybe.Just(emailValidationPhaseIdle);
    };
    if (value === "loading") {
        return new Data_Maybe.Just(emailValidationPhaseLoading);
    };
    if (value === "success") {
        return new Data_Maybe.Just(emailValidationPhaseSuccess);
    };
    if (value === "error") {
        return new Data_Maybe.Just(emailValidationPhaseError);
    };
    return Data_Maybe.Nothing.value;
};
var readEmailValidationPhase = {
    readImpl: function (value) {
        return bind(readImpl(value))(function (raw) {
            var v = emailValidationPhaseFromString(raw);
            if (v instanceof Data_Maybe.Just) {
                return pure1(v.value0);
            };
            if (v instanceof Data_Maybe.Nothing) {
                return fail(new Foreign.ForeignError("Invalid EmailValidationPhase: " + raw));
            };
            throw new Error("Failed pattern match at Ouroboros.Models.Ui.EmailValidationPhase (line 68, column 5 - line 70, column 87): " + [ v.constructor.name ]);
        });
    }
};
var emailValidationPhaseNamespace = {
    idle: emailValidationPhaseIdle,
    loading: emailValidationPhaseLoading,
    success: emailValidationPhaseSuccess,
    error: emailValidationPhaseError
};
export {
    emailValidationPhaseIdle,
    emailValidationPhaseLoading,
    emailValidationPhaseSuccess,
    emailValidationPhaseError,
    emailValidationPhaseNamespace,
    emailValidationPhaseFromString,
    emailValidationPhaseToString,
    eqEmailValidationPhase,
    ordEmailValidationPhase,
    showEmailValidationPhase,
    readEmailValidationPhase,
    writeEmailValidationPhase,
    tsBridgeEmailValidationPh
};
//# sourceMappingURL=index.js.map
